import React, { FC } from "react";

interface Props {
  className?: string;
}

export const Text: FC<Props> = ({ children, className }) => {
  return (
    <p
      tw="font-medium text-sm leading-6 text-[#000] whitespace-pre-wrap break-all"
      className={className}
    >
      {children}
    </p>
  );
};
